import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toFarsiNumber } from "../../cudtom-hooks/en-to-persian";
import { updatePending } from "../common-states/commonStatesSlice";

const config = {
  headers: { Authorization: `Token ${localStorage.getItem('token')}` }
};

export const getReportData = createAsyncThunk("report/getReportData", async (data) => {
  const { searchParam, filterStatus, pageNum, englishStartDate, englishEndDate, dispatch } = data;
  let bodyArray = [];

  dispatch(updatePending(true));

  // 1. Fetch detailed list (for table rows)
  await axios.get(
    `https://api.khedmatashayer-kj.ir/v1/nomad/tanker-request/${pageNum}?${filterStatus ? 'start_created_at' : 'start_scheduled_to_deliver_at'}=${englishStartDate}&${filterStatus ? 'end_created_at' : 'end_scheduled_to_deliver_at'}=${englishEndDate}&${searchParam}`,
    config
  )
    .then((res) => {
      const requests = res.data || [];
      requests.forEach((item) => {
        let deliveredDate = item.nomad_confirmed_at ? new Date(item.nomad_confirmed_at).toLocaleDateString('fa-IR') : '-';
        let scheduledToDeliverDate = item.scheduled_to_deliver_at ? new Date(item.scheduled_to_deliver_at).toLocaleDateString('fa-IR') : '-';
        let allocatedDate = item.driver_allocated_at ? new Date(item.driver_allocated_at).toLocaleDateString('fa-IR') : '-';
        let createdDate = new Date(item.created_at).toLocaleDateString('fa-IR');
        bodyArray.push([
          deliveredDate,
          scheduledToDeliverDate,
          item.driver?.name || '-',
          allocatedDate,
          createdDate,
          item.water_volume,
          item.region,
          item.city,
          item.nomad?.name,
          item.water_type === 1 ? 'آب شرب' : 'آب دام'
        ]);
      });
    })
    .catch(() => {
      alert('خطا در برقراری ارتباط با سرور');
    });

  // 2. Fetch reporting box data + aggregate metrics (households, livestock, distance)
  let reportingBoxData = [];
  let aggregateMetrics = {
    totalHouseholds: 0,
    totalLivestock: 0,
    totalDistanceKm: 0
  };

  await axios.get(
    `https://api.khedmatashayer-kj.ir/v1/nomad/tanker-request/filter?${filterStatus ? 'start_delivered_at' : 'start_created_at'}=${englishStartDate}&${filterStatus ? 'end_delivered_at' : 'end_created_at'}=${englishEndDate}&${searchParam}`,
    config
  )
    .then((res) => {
      let data = res.data;
      // Existing box data
      reportingBoxData = [
        [
          data.livestock_water_count,
          data.delivered_livestock_water_count,
          data.livestock_water,
          data.delivered_livestock_water,
          data.rejected_livestock_water_count
        ],
        [
          data.drinkable_water_count,
          data.delivered_drinkable_water_count,
          data.drinkable_water,
          data.delivered_drinkable_water,
          data.rejected_drinkable_water_count
        ],
        [
          data.livestock_water_count + data.drinkable_water_count,
          data.delivered_livestock_water_count + data.delivered_drinkable_water_count,
          data.livestock_water + data.drinkable_water,
          data.delivered_livestock_water + data.delivered_drinkable_water,
          data.rejected_livestock_water_count + data.rejected_drinkable_water_count
        ]
      ];
      reportingBoxData = reportingBoxData.map((item) =>
        item.map((value) => toFarsiNumber(value))
      );

      // New aggregate metrics from the same response
      aggregateMetrics = {
        totalHouseholds: data.households_count || 0,
        totalLivestock: data.livestock_count || 0,
        totalDistanceKm: data.dewatering_distance_sum || 0
      };
    })
    .catch(() => {
      alert('خطا در برقراری ارتباط با سرور');
    });

  dispatch(updatePending(false));

  return { bodyArray, reportingBoxData, aggregateMetrics };
});

const reportSlice = createSlice({
  name: 'report',
  initialState: {
    bodyArray: [],
    reportingBoxData: [],
    aggregateMetrics: {
      totalHouseholds: 0,
      totalLivestock: 0,
      totalDistanceKm: 0
    }
  },
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getReportData.fulfilled, (state, action) => {
      return { ...state, ...action.payload };
    });
  }
});

export const selectReportBodyArray = (state) => state.report.bodyArray;
export const selectReportingBoxData = (state) => state.report.reportingBoxData;
export const selectAggregateMetrics = (state) => state.report.aggregateMetrics;

export default reportSlice.reducer;
